<template>
  <div class="panel-container">
    <!-- 头部容器 -->
    <div class="header-container">
      <!-- 标题 -->
      <div class="title-container">
        <span class="title-text">{{ $str.getKey('收益管理/收益统计') }}</span>
      </div>
      <!-- 操作按钮 -->
      <div class="btns-container">
      </div>
    </div>
    <!-- 主体容器 -->
    <div class="main-container">
      <!-- 收益统计图 -->
      <v-chart 
        v-if="panelData.incomeOption" 
        :key="`income-${chartData?.income?.length || 0}`"
        class="chart-container" 
        :option="panelData.incomeOption" 
        :autoresize="true" 
      />
    </div>

  </div>
</template>

<script setup>
import { ref, reactive, watch, onMounted, onBeforeUnmount } from "vue"
import dayjs from 'dayjs';
import { getChartOption as getIncomeChartOption } from "./incomeChartOptions.js"

const $str = window.$str;


/** 设置组件配置项 */
defineOptions({
  name: "chartPanel"
});

/** 接收父组件信息 */
const props = defineProps({
  chartData: {
    type: Object,
    default: {
      income: [],
      kwh: [],
    }
  },
});


const panelData = reactive({
  incomeOption: getIncomeChartOption(props.chartData?.income || []),
})





initPanel();


const isMounted = ref(false);

onMounted(() => {
  isMounted.value = true;
})

const stopWatch = watch(() => props.chartData?.income, (nv) => {
  if (isMounted.value && nv !== undefined) {
    panelData.incomeOption = getIncomeChartOption(nv);
  }
}, { immediate: false })

onBeforeUnmount(() => {
  isMounted.value = false;
  stopWatch();
})




// /** ====== [业务：功能方法] =================================================================== */
/** 初始化面板 */
function initPanel() {

}



/** ====== [辅助：功能方法] =================================================================== */






</script>
<style lang="scss" scoped>
.panel-container {
  --header-height: 50px;
  & {
    width: 100%;
    height: 100%;
    // 由外层卡片（overview-block）负责白底与阴影，这里只做内容布局，贴近 Figma 的简洁风格
    background: transparent;
    border-radius: 0;
    border: none;
    padding: 20px;
  
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .header-container {
    width: 100%;
    height: var(--header-height);
    min-height: var(--header-height);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0;
    margin-bottom: 16px;

    .title-container {
      flex: 1;
      height: 100%;
      display: flex;
      align-items: center;
      padding: 0;
      
      .title-text {
        color: #2E2E2E;
        font-family: "HarmonyOS Sans SC";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }

    .btns-container {
      flex-shrink: 0;
      height: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 0;
    }
  }

  .main-container {
    & {
      width: 100%;
      height: calc(100% - var(--header-height) - 16px);
      box-sizing: border-box;
      flex: 1;
      // 去掉内层边框与卡片，改为干净的图表区域，保持与 Figma 一致
      border: none;
      border-radius: 0;
      padding: 0;

      display: flex;
      flex-direction: column;
      gap: 0;
    }

    .chart-container {
      width: 100%;
      height: 100%;
      flex: 1;
      background: transparent;
      padding: 0;
    }

  }

}

// 收益统计图 tooltip 布局优化，参考截图（不改颜色，只改布局与背景）
::v-deep .chart-tooltip {
  padding: 12px 16px !important;
  border-radius: 8px !important;
}

::v-deep .chart-tooltip__time {
  margin-bottom: 8px;
  font-family: "HarmonyOS Sans SC";
  font-size: 14px;
}

::v-deep .chart-tooltip__items-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

::v-deep .chart-tooltip__series {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 6px 10px;
  border-radius: 6px;
}

::v-deep .chart-tooltip__point {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 6px;
}

::v-deep .chart-tooltip__series-name {
  font-family: "HarmonyOS Sans SC";
  font-size: 13px;
  margin-right: 8px;
}

::v-deep .chart-tooltip__value {
  font-family: "HarmonyOS Sans SC";
  font-size: 14px;
  font-weight: 600;
}

</style>
